module.exports = __webpack_public_path__ + "img/navos.edb892e0.svg";